export class FontsLoader {
    constructor(path) {
        this.path = path;
        this.fonts = [];
    }

    load(fontName) {
        let that = this;
        opentype.load(that.path+'/'+fontName+'.ttf', function (err, font) {
            if (err) {
                alert('Could not load font: ' + err);
            } else {
                let f = {name: fontName, font: font};
                that.fonts.push(f);
                //console.log(that);

            }
        });
    }

    getFonts(){
        return this.fonts;
    }
}
